module.exports = __webpack_public_path__ + "static/media/8-8.36c53143.mp3";